import { CircleInfo } from '@unified-checkout/design-system/icons/index';
import { SkeletonLoader, Tooltip } from '@unified-checkout/design-system';

import { ComponentError } from '@app/dashboard/components/shared/ComponentError';

import type { IAnalyticCard } from '@app/dashboard/types/innerLayout/balance_and_transfers/transfers/analytics-cards';

import styles from './cards.module.scss';

const Cards = ({
  title,
  tooltipProps,
  icon,
  amount,
  supportingText,
  isLoading,
  isError,
  errorText,
}: IAnalyticCard) => {
  const hasValuesSection = !!supportingText || !!amount;

  return isError ? (
    <div className={styles['cards']} data-analytics-error={isError}>
      <ComponentError text={errorText} />
    </div>
  ) : isLoading ? (
    <div className={styles['cards']}>
      <SkeletonLoader
        width="100%"
        height="9rem"
        noOfRows={4}
        key={`analytic-card-skeleton-loader-${title}`}
        type="transparent_box"
      />
    </div>
  ) : (
    <div className={styles['cards']}>
      {icon}
      <div className={styles['cards__content']}>
        {title && (
          <div className={styles['cards__title']}>
            <p className={styles['cards__title-text']}>{title}</p>
            {tooltipProps && (
              <Tooltip {...tooltipProps} centerArrow>
                <div className={styles['cards__title-tooltip']}>
                  {CircleInfo}
                </div>
              </Tooltip>
            )}
          </div>
        )}
        {hasValuesSection && (
          <div className={styles['cards__values']}>
            <p className={styles['cards__values-amount']}>{amount}</p>
            <p className={styles['cards__values-total']}>{supportingText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cards;
